// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yxG8","top":"styles_top__1WIf7"};